import React, { useState } from "react";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import styles from "./GameButtons.module.css";
import { UNLIMITED_TIER } from "@chesshotel/constants";
import {
  declineRematch,
  useGamePlay,
  rematchSent,
} from "../../../ducks/gamePlay";
import { useMembership } from "../../../ducks/membership";
import Link from "next/link";
import { useSiteData } from "../../../ducks/siteData";
import { GamePlayWs } from "../../../services/wsOutRoutes";
import GroupButton, {
  FIRST_BTN,
  LAST_BTN,
  MIDDLE_BTN,
} from "@/src/components/GroupButton";
import { useAnalysis } from "@/src/ducks/analysis";
import { Button } from "@/src/components/ui/button";
import { MoveType } from "@chesshotel/types";

function sendRematch() {
  GamePlayWs.sendRematch();
  rematchSent();
}

export default function GameEndedButtons({
  isDesktop,
  setChatOpened,
  handleShowChatWindow,
  unreadChatMessages,
}) {
  const router = useRouter();

  const { rematchReceived, rematchSent, displayGame, leaguePlay } =
    useGamePlay();

  // const { iframeMode } = useSiteData();

  const { leagueGames, tier } = useMembership();
  const { lobbyPath } = useSiteData();

  const [rematchAnswered, setRematchAnswered] = useState(false);
  const { t } = useTranslation("common");

  let blunders: number = 0,
    misstakes: number = 0,
    inaccuracies: number = 0;
  // good: number = 0;
  const { gameReview } = useAnalysis();

  gameReview.forEach((position) => {
    switch (position.type) {
      case MoveType.BLUNDER:
        blunders++;
        break;
      case MoveType.MISTAKE:
        misstakes++;
        break;
      case MoveType.INACCURACY:
        inaccuracies++;
        break;
      // case MoveType.GOOD:
      //   good++;
      //   break;
    }
  });

  function answerRematch(accepted) {
    setRematchAnswered(true);
    if (accepted) {
      sendRematch();
    } else {
      declineRematch();
    }
  }

  function gotoLobby() {
    router.push("/lobby");
  }

  function gotoAnalysis() {
    router.push("/analysis");
  }

  function renderRematchReceived() {
    return (
      <div className={styles.rematchReceived}>
        {t("Your opponent wants to play a rematch")}
        <div className={styles.btnGroupCont}>
          <div className={styles.btnGroup}>
            <button onClick={() => answerRematch(true)}>{t("Yes")}</button>
            <button onClick={() => answerRematch(false)}>{t("No")}</button>
          </div>
        </div>
      </div>
    );
  }

  function renderMenu() {
    const rematchPossible =
      !leaguePlay || leagueGames > 0 || tier === UNLIMITED_TIER;

    if (isDesktop) {
      return (
        <>
          {/* <div className="flex justify-around w-full py-3 text-xs ">
            <div className="flex flex-col items-center gap-1">
              <div className="flex items-center justify-center w-5 h-5 font-bold text-white bg-red-400 rounded-full ">
                {blunders}
              </div>
              <div>Blunder</div>
            </div>
            <div className="flex flex-col items-center gap-1">
              <div className="flex items-center justify-center w-5 h-5 font-bold text-white bg-orange-400 rounded-full ">
                {misstakes}
              </div>
              <div>Misstake</div>
            </div>
            <div className="flex flex-col items-center gap-1">
              <div className="flex items-center justify-center w-5 h-5 font-bold text-white bg-orange-400 rounded-full ">
                {inaccuracies}
              </div>
              <div>Miss</div>
            </div>
          </div> */}
          {/* <div className="flex flex-col gap-3">
            <Link href={"/game-review/start"}>
              <Button className="h-10" size="full">
                {"Game review"}
              </Button>
            </Link>
            <div className="flex gap-3">
              <Button onClick={gotoLobby} variant="outline" size="full">
                {t("New game")}
              </Button>
              {rematchPossible && (
                <Button
                  disabled={rematchSent || rematchReceived}
                  onClick={sendRematch}
                  variant="outline"
                  size="full"
                >
                  {t("Rematch")}
                </Button>
              )}
            </div>
          </div> */}

          <div className="flex flex-col gap-3">
            {/* <Link href={"/game-review/start"}> */}
            <Button onClick={gotoLobby} className="h-10" size="full">
              {t("New game")}
            </Button>
            {/* </Link> */}
            <div className="flex gap-3">
              <Button onClick={gotoAnalysis} variant="outline" size="full">
                {t("Analyze game")}
              </Button>
              {rematchPossible && (
                <Button
                  disabled={rematchSent || rematchReceived}
                  onClick={sendRematch}
                  variant="outline"
                  size="full"
                >
                  {t("Rematch")}
                </Button>
              )}
            </div>
          </div>

          {/* <button onClick={gotoLobby} className="btn btn-blue btn-sm">
            {t("New game")}
          </button>
          <div className={styles.btnGroup}>
            {rematchPossible && (
              <button
                disabled={rematchSent || rematchReceived}
                onClick={sendRematch}
              >
                {t("Rematch")}
              </button>
            )}
            <button onClick={gotoAnalysis}>{t("Analyze game")}</button>
          </div> */}
        </>
      );
    } else {
      return (
        <div className="flex flex-col items-center space-y-3">
          {/* <div className="flex justify-around text-sm ">
            <div className="flex items-center gap-1">
              <div>Blunders</div>
              <div className="flex items-center justify-center w-8 h-8 font-bold bg-red-400 rounded-full ">
                {blunders}
              </div>
            </div>
            <div className="flex items-center gap-1">
              <div>Misstakes</div>
              <div className="flex items-center justify-center w-8 h-8 font-bold bg-orange-400 rounded-full ">
                {misstakes}
              </div>
            </div>
            <div className="flex items-center gap-1">
              <div>Inaccuracies</div>
              <div className="flex items-center justify-center w-8 h-8 font-bold bg-orange-400 rounded-full ">
                {inaccuracies}
              </div>
            </div>
          </div> */}

          <Link href={lobbyPath}>
            <button className="btn btn-blue btn-sm">{t("New game")}</button>
          </Link>
          <div className="flex">
            <GroupButton buttonType={FIRST_BTN} onClick={sendRematch}>
              {t("Rematch")}
            </GroupButton>
            <GroupButton buttonType={MIDDLE_BTN} onClick={gotoAnalysis}>
              {t("Analyze game")}
            </GroupButton>
            <GroupButton
              buttonType={LAST_BTN}
              onClick={() => {
                setChatOpened(true);
                handleShowChatWindow(true);
              }}
              badgeNum={unreadChatMessages}
            >
              {t("Chat")}
            </GroupButton>
          </div>
          {/* {!iframeMode && (
            <button
              className="btn btn-outline btn-xs md:btn-sm"
              onClick={gotoAnalysis}
            >
              {t("Analyze game")}
            </button>
          )} */}
        </div>
      );
    }
  }

  if (displayGame) {
    return (
      <div className={styles.gameEndedButtons}>
        <button className="btn btn-blue btn-base" onClick={gotoAnalysis}>
          {t("Analyze game")}
        </button>
      </div>
    );
  } else {
    return (
      <div className="w-full px-4 py-1 ">
        {rematchReceived && !rematchAnswered && renderRematchReceived()}
        {renderMenu()}
      </div>
    );
  }
}
